import { DomainError } from '@/core/errors/DomainError';
import type { FormatId } from '@/core/schemas';

import type { TournamentFormat } from './contracts';
import { groupStageFormat } from './formats/groupStage';
import { singleEliminationFormat } from './formats/singleElimination';

/**
 * The list of available tournament formats.
 *
 * Adding Doppel-KO, Schweizer System, Round Robin or a league means writing a
 * new folder under `formats/` and adding one line here. No existing code
 * changes — that is the whole point of the format interface.
 */
const FORMATS: readonly TournamentFormat[] = [groupStageFormat, singleEliminationFormat];

const byId = new Map<string, TournamentFormat>(FORMATS.map((format) => [format.id, format]));

export function listFormats(): readonly TournamentFormat[] {
  return FORMATS;
}

export function findFormat(formatId: FormatId): TournamentFormat | undefined {
  return byId.get(formatId);
}

/** Like {@link findFormat}, but fails loudly — used where a format is required. */
export function requireFormat(formatId: FormatId): TournamentFormat {
  const format = byId.get(formatId);

  if (format === undefined) {
    throw new DomainError(
      'UNKNOWN_FORMAT',
      `Das Turnierformat "${formatId}" ist nicht bekannt. Verfügbar: ${[...byId.keys()].join(', ')}.`,
      { formatId },
    );
  }

  return format;
}
